module.exports = __webpack_public_path__ + "static/media/integration.c4f8757c.svg";